import React from "react";
import { Badge } from "@/components/ui/badge";

export const money = (n) =>
  "₹" + Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 });

export function PageHeader({ title, subtitle, action, icon: Icon }) {
  return (
    <div className="flex flex-col gap-4 border-b border-border pb-6 sm:flex-row sm:items-end sm:justify-between">
      <div className="animate-fade-up">
        <div className="mb-1 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-primary">
          {Icon && <Icon className="h-3.5 w-3.5" />}
          <span>Aranya Exim</span>
        </div>
        <h1 className="font-heading text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
          {title}
        </h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

const STATUS_MAP = {
  pass: "bg-sage/15 text-sage border-sage/30",
  completed: "bg-sage/15 text-sage border-sage/30",
  done: "bg-sage/15 text-sage border-sage/30",
  operational: "bg-sage/15 text-sage border-sage/30",
  dispatched: "bg-sage/15 text-sage border-sage/30",
  received: "bg-sage/15 text-sage border-sage/30",
  pending: "bg-ochre/15 text-ochre border-ochre/30",
  draft: "bg-muted text-muted-foreground border-border",
  in_progress: "bg-[#4A5D6E]/15 text-[#4A5D6E] border-[#4A5D6E]/30",
  in_production: "bg-[#4A5D6E]/15 text-[#4A5D6E] border-[#4A5D6E]/30",
  ordered: "bg-[#4A5D6E]/15 text-[#4A5D6E] border-[#4A5D6E]/30",
  needs_service: "bg-ochre/15 text-ochre border-ochre/30",
  under_repair: "bg-ochre/15 text-ochre border-ochre/30",
  fail: "bg-destructive/10 text-destructive border-destructive/30",
  rework: "bg-destructive/10 text-destructive border-destructive/30",
  out_of_order: "bg-destructive/10 text-destructive border-destructive/30",
};

export function StatusBadge({ status }) {
  const cls = STATUS_MAP[status] || "bg-muted text-muted-foreground border-border";
  const label = (status || "").replace(/_/g, " ");
  return (
    <Badge variant="outline" className={`rounded-full border px-2.5 py-0.5 text-[11px] font-semibold capitalize ${cls}`}>
      {label}
    </Badge>
  );
}

export function EmptyState({ icon: Icon, title, hint }) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-md border border-dashed border-border bg-card/50 py-16 text-center">
      {Icon && <Icon className="h-8 w-8 text-muted-foreground/60" />}
      <div>
        <p className="font-heading text-base font-semibold text-foreground">{title}</p>
        {hint && <p className="mt-1 text-sm text-muted-foreground">{hint}</p>}
      </div>
    </div>
  );
}
